import $ from 'jquery';

import CoreModel from 'core/models/core';


export default CoreModel.extend({
  urlRoot: API_PREFIX + window.Urls['accounts_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'user',
  }),

  save: function (attributes, options) {
    this.urlRoot += 'register/';
    var xhr = CoreModel.prototype.save.apply(this, [
      null,
      _.extend(options, {
        data: $.param(attributes),
      })
    ]);
    this.urlRoot = this.urlRoot.replace('register/', '');
    return xhr;
  }
});



// WEBPACK FOOTER //
// ./static/js/models/user.js